import { CommonModule, DatePipe } from '@angular/common';
import { NgModule } from '@angular/core';

import { GasDatePipe } from './gas-date.pipe';

const PIPES = [
  GasDatePipe,
];

@NgModule({
  declarations: [
    PIPES,
  ],
  exports: [
    PIPES,
  ],
  imports: [
    CommonModule,
  ],
  providers: [
    DatePipe,
  ],
})
export class GasDatePipeModule  { }
